'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Icon } from '@/shared/ui/icon'

import { Product } from '../../api/search.api'

import cl from './style.module.scss'

export interface ProductsListProps {
	items: Product[]
	link: string
}

export const ProductsList = (props: ProductsListProps) => {
	const { items, link } = props
	const router = useRouter()
	const handleLinkClick = async () => await router.push(link)

	return (
		<div className={cl.root}>
			<div className={cl.products}>
				{items?.map(product => (
					<Link prefetch={false} key={product.code} className={cl.product} href={`/products/${product.code}/`}>
						<Image src={product.image} alt={product.name} width={80} height={52} className={cl.img} />

						<div className={cl.description}>
							<h4 className={cl.title}>{product.name}</h4>
							{product?.price && Number(product?.price) > 0 && product.price !== '9999999.00' && (
								<p className={cl.price}>
									{formatPrice(Number(product.price))}
									{product?.old_price && <small>{formatPrice(Number(product.old_price))}</small>}
								</p>
							)}
						</div>
					</Link>
				))}
			</div>
			{link && (
				<button onClick={handleLinkClick} className={cl.link}>
					Смотреть все результаты
					<Icon name={'ArrowRight'} size={16} />
				</button>
			)}
		</div>
	)
}
